import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import moment from "moment";
import { useMediaQuery } from "react-responsive";
import { useEffect, useState } from "react";

const ProjectFullCalendar = ({
  data,
  calendarRef,
  handleDateClick,
  handleEventClick,
  containerRef,
}) => {
  const isMobile = useMediaQuery({ query: "(max-width:767px)" });
  const [contentHeight, setContentHeight] = useState(null);

  useEffect(() => {
    const updateContentHeight = () => {
      if (containerRef.current) {
        console.log(containerRef.current.clientHeight - 100);
        setContentHeight(containerRef.current.clientHeight - 100);
      }
    };

    updateContentHeight();
    window.addEventListener("resize", updateContentHeight);
    return () => window.removeEventListener("resize", updateContentHeight);
  }, []);

  return (
    <FullCalendar
      ref={calendarRef}
      plugins={[dayGridPlugin, interactionPlugin]}
      locale="ko"
      events={data}
      moreLinkContent={(info) => `+${info.num}`}
      eventClick={(info) => handleEventClick(info.el)}
      dayMaxEvents={2}
      fixedWeekCount={isMobile ? false : true}
      eventClassNames={(info) =>
        `schedule-${info.event.id}${info.event.extendedProps.completeYn === "Y" ? " complete" : ""}`
      }
      dateClick={(info) => handleDateClick(info.dateStr)}
      contentHeight={contentHeight}
      dayCellContent={(info) => (
        <>
          <div></div>
          <div className="date">
            <span>{moment(info.date).format("D")}</span>
          </div>
        </>
      )}
    />
  );
};

export default ProjectFullCalendar;
